





























import {Component, Prop} from 'vue-property-decorator';
import {Mixins} from 'vue-mixin-decorator';
import {BaseComponent} from '@/mixins/BaseComponent';

import {Profile} from '@/model/network/profile/Profile';
import {IpMode} from '@/model/network/IpMode';

import NetworkIpSettingsDisplay from '@/components/Networking/Profile/NetworkIpSettingsDisplay.vue';
import NetworkIpSettingsDisplayHeader from '@/components/Networking/Profile/NetworkIpSettingsDisplayHeader.vue';

@Component({
  components: {NetworkIpSettingsDisplayHeader, NetworkIpSettingsDisplay},
})
export default class NetworkIpSettings extends Mixins<BaseComponent>(BaseComponent) {

  private IpMode = IpMode;

  @Prop(Object)
  private profile!: Profile;
}
